import { render, staticRenderFns } from "./ques72.vue?vue&type=template&id=db8b05da&scoped=true"
import script from "./ques72.vue?vue&type=script&lang=js"
export * from "./ques72.vue?vue&type=script&lang=js"
import style0 from "./ques72.vue?vue&type=style&index=0&id=db8b05da&prod&lang=css"
import style1 from "./ques72.vue?vue&type=style&index=1&id=db8b05da&prod&lang=css"
import style2 from "./ques72.vue?vue&type=style&index=2&id=db8b05da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8b05da",
  null
  
)

export default component.exports